/** @format */
import angular from 'angular';
import { courseUnitInfoSectionModule } from './courseUnitInfoSection.component';
angular.module('student.common.components.module-info.modal', [courseUnitInfoSectionModule]);